export enum PLAN_VERSION_TYPE {
  actual = 'actual',
  archive = 'archive',
  analytics = 'analytics',
  integration = 'integration',
}
